module.exports = __webpack_public_path__ + "img/call-icon.45846b15.svg";